import { WidgetAPI } from "@/context/widget-context";
import { Language, useTranslations } from "@/lib";
import { Button } from "../ui/button";
import { ProductItem } from "./products/product-item";
export function TryBundle({
  widget,
  lang,
}: {
  widget: WidgetAPI;
  lang: Language;
}) {
  return (
    <div className="tw:grid tw:gap-5 tw:px-4">
      {widget.products
        .filter((product) => product.size)
        .map((product, index) => (
          <ProductItem key={index} product={product} lang={lang} />
        ))}
    </div>
  );
}
export function TryBundleButton({
  lang,
  widget,
}: {
  lang: Language;
  widget: WidgetAPI;
}) {
  const { t } = useTranslations(lang);
  return (
    <div className="tw:p-4">
      <div className="tw:text-lg tw:mb-1 tw:font-semibold">
        {t("try_bundler_content.heading")}
      </div>
      <div className="tw:mb-1">
        {t("try_bundler_content.first_description.first_text")}{" "}
        <strong>
          {t("try_bundler_content.first_description.second_text.bold_text")}
        </strong>{" "}
        {t("try_bundler_content.first_description.third_text")}{" "}
        <strong>
          {t("try_bundler_content.first_description.fourth_text.bold_text")}
        </strong>
      </div>
      <div className="tw:text-sm">
        {t("try_bundler_content.first_description.fifth_text")}
      </div>
      <div className="tw:md:grid tw:md:grid-cols-3 tw:md:gap-4 tw:mt-2 tw:md:mt-7 tw:flex tw:justify-between">
        <Button
          onClick={() => {
            // remove the products without size
            const existingProduct = widget.products.find(
              (product) => !product.size,
            );
            if (existingProduct) {
              widget.removeProduct(existingProduct.id);
            }

            widget.setStep(4);
          }}
          variant="outline"
          className="tw:md:col-span-1 tw:w-[40%] tw:md:w-[auto] tw:!text-sm tw:md:!text-base tw:!h-13.5"
        >
          {t("try_bundler_content.left_button_text")}
        </Button>
        <Button
          className="tw:md:col-span-2 tw:w-[55%] tw:md:w-[auto] tw:!text-sm tw:md:!text-base tw:!h-13.5"
          onClick={() => widget.setStep(3)}
        >
          {t("try_bundler_content.right_button_text")}
        </Button>
      </div>
    </div>
  );
}
